import api from "./api";

export const getAllLevel2Resources = async (
  params: { parentId?: string } = {}
) => {
  const { data } = await api.get("/admin/level2Resources", { params });
  return data.level2Resources ?? [];
};
